import { TableColumn } from '../models/table-column.model';
import { ISeriesPoint } from '../models/series-point.model';

/** Fila de la tabla de palancas (menciones agregadas del análisis de texto). */
export interface IPalancaRow {
  palanca: string;
  menciones: number;
  mencionesPct: number;
}

/** Comentario individual que sustenta una palanca (tabla del modal "Detalle"). */
export interface IComentarioRow {
  nombre: string;
  apellidos: string;
  nps: number;
  region: string;
  zona: string;
  sucursal: string;
  palanca?: string;
}

/** Serie de columnas agrupadas de "Orientación por palanca". */
export interface IOrientacionSerie {
  name: string;
  color: string;
  data: Array<number>;
}

/* -------------------------------------------------------------------------- */
/*                              ANCHOR palancas                               */
/* -------------------------------------------------------------------------- */

export const PALANCAS: Array<string> = [
  'PROTOCOLOS DE ATENCION A CLIENTE',
  'EXPERIENCIA DE PRODUCTOS',
  'PERCEPCION DE LOS PRECIOS',
  'EXPERIENCIA EN TIENDA',
  'PROTOCOLOS DE ATENCION A CLIENTE EN CREMERIA',
  'PROMOCIONES',
  'EXPERIENCIA DE PRODUCTOS EN CREMERIA',
  'SEGURIDAD EN TIENDA',
];

/**
 * Línea teal descendente: % de mención de cada palanca sobre el total.
 * Son los mismos ocho porcentajes que los drivers de recomendación del Pulso:
 * es el mismo reparto leído desde el texto abierto en vez de la pregunta cerrada.
 */
export const MENCION_POR_PALANCA: Array<ISeriesPoint> = [
  { label: 'PROTOCOLOS DE ATENCION A CLIENTE', value: 34 },
  { label: 'EXPERIENCIA DE PRODUCTOS', value: 23 },
  { label: 'PERCEPCION DE LOS PRECIOS', value: 13 },
  { label: 'EXPERIENCIA EN TIENDA', value: 11 },
  { label: 'PROTOCOLOS DE ATENCION A CLIENTE EN CREMERIA', value: 6 },
  { label: 'PROMOCIONES', value: 7 },
  { label: 'EXPERIENCIA DE PRODUCTOS EN CREMERIA', value: 5 },
  { label: 'SEGURIDAD EN TIENDA', value: 1 },
];

/* -------------------------------------------------------------------------- */
/*                             ANCHOR orientación                             */
/* -------------------------------------------------------------------------- */

/** Cada palanca reparte 100 entre las tres orientaciones. */
export const ORIENTACION_POR_PALANCA: Array<IOrientacionSerie> = [
  { name: 'Positivo', color: '#46b1ff', data: [38, 28, 29, 39, 29, 39, 31, 41] },
  { name: 'Neutro',   color: '#f6860a', data: [9, 9, 16, 9, 13, 9, 10, 16] },
  { name: 'Negativo', color: '#f9c433', data: [53, 63, 55, 52, 58, 52, 59, 43] },
];

/* -------------------------------------------------------------------------- */
/*                          ANCHOR tabla de palancas                          */
/* -------------------------------------------------------------------------- */

export const COLUMNAS_PALANCAS: Array<TableColumn> = [
  { key: 'palanca',      title: 'Palanca/Neto' },
  { key: 'menciones',    title: 'Menciones',   cellStyle: 'center' },
  { key: 'mencionesPct', title: 'Menciones %', cellStyle: 'center', suffix: '%' },
  { key: 'detalle',      title: 'Detalle',     cellStyle: 'icon', icon: 'bi-file-earmark-text', sortable: false },
];

/** Las menciones suman 2947, el total de comentarios clasificados del periodo. */
export const FILAS_PALANCAS: Array<IPalancaRow> = [
  { palanca: 'PROTOCOLOS DE ATENCION A CLIENTE',              menciones: 1002,  mencionesPct: 34 },
  { palanca: 'EXPERIENCIA DE PRODUCTOS',                      menciones: 678,   mencionesPct: 23 },
  { palanca: 'PERCEPCION DE LOS PRECIOS',                     menciones: 383,   mencionesPct: 13 },
  { palanca: 'EXPERIENCIA EN TIENDA',                         menciones: 324,   mencionesPct: 11 },
  { palanca: 'PROTOCOLOS DE ATENCION A CLIENTE EN CREMERIA',  menciones: 177,   mencionesPct: 6 },
  { palanca: 'PROMOCIONES',                                   menciones: 206,   mencionesPct: 7 },
  { palanca: 'EXPERIENCIA DE PRODUCTOS EN CREMERIA',          menciones: 147,   mencionesPct: 5 },
  { palanca: 'SEGURIDAD EN TIENDA',                           menciones: 29,    mencionesPct: 1 },
];

/* -------------------------------------------------------------------------- */
/*                       ANCHOR detalle de comentarios                        */
/* -------------------------------------------------------------------------- */

export const COLUMNAS_DETALLE: Array<TableColumn> = [
  { key: 'nombre',    title: 'NOMBRE' },
  { key: 'apellidos', title: 'APELLIDOS' },
  { key: 'nps',       title: 'NPS', cellStyle: 'center' },
  { key: 'region',    title: 'REGIÓN' },
  { key: 'zona',      title: 'ZONA' },
  { key: 'sucursal',  title: 'SUCURSAL' },
  { key: 'palanca',   title: 'PALANCA/NETO' },
];

/** Base de encuestados que se reetiqueta con la palanca elegida al abrir el modal. */
export const COMENTARIOS_DETALLE: Array<IComentarioRow> = [
  { nombre: 'Adriana', apellidos: 'Camacho Rendón', nps: 9, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ARAGÓN' },
  { nombre: 'Efraín', apellidos: 'Gaytán Prieto', nps: 2, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL MARIANO ESCOBEDO LEON' },
  { nombre: 'Hugo', apellidos: 'Manríquez Solís', nps: 8, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL AVENIDA CENTRAL' },
  { nombre: 'Ma. del Refugio', apellidos: 'Robledo Cifuentes', nps: 8, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL TULTITLAN' },
  { nombre: 'Silvestre', apellidos: 'Zúñiga Arriaga', nps: 8, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL CAZADOR NAUCALPAN' },
  { nombre: 'Cecilia', apellidos: 'Delgadillo Rueda', nps: 0, region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 3' },
  { nombre: 'Gerardo', apellidos: 'Ibarra Montiel', nps: 5, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL IGUALA 2' },
  { nombre: 'Lorenzo', apellidos: 'Ojeda Villalobos', nps: 9, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ATIZAPAN 2' },
  { nombre: 'Rocío', apellidos: 'Terán Osorio', nps: 6, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL PROFETA' },
  { nombre: 'Bernardo', apellidos: 'Bautista Ordaz', nps: 9, region: 'LEONARDO MAXIMO', zona: 'ISMAEL FERMIN', sucursal: 'SUCURSAL AZTAHUACAN' },
  { nombre: 'Esperanza', apellidos: 'Fierro Alcántara', nps: 1, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL ALTA TENSION' },
  { nombre: 'Jimena', apellidos: 'Lugo Mercado', nps: 9, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL CHALCO' },
  { nombre: 'Ofelia', apellidos: 'Quintero Amaya', nps: 8, region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL AMECAMECA' },
  { nombre: 'Alma Delia', apellidos: 'Valencia Pineda', nps: 9, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL LEON 2' },
  { nombre: 'Elsa', apellidos: 'Cervantes Olmos', nps: 10, region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL AV. 11 SUR' },
  { nombre: 'Isaura', apellidos: 'Hinojosa Cuevas', nps: 2, region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL TOLUCA 1' },
  { nombre: 'Nayeli', apellidos: 'Nolasco Cabrera', nps: 6, region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL CAZADOR' },
  { nombre: 'Yolanda', apellidos: 'Salgado Beltrán', nps: 6, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 2' },
  { nombre: 'Daniel', apellidos: 'Aguirre Peralta', nps: 2, region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL ECATEPEC' },
  { nombre: 'Gloria', apellidos: 'Estrada Bermúdez', nps: 10, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ARAGÓN' },
  { nombre: 'Marcela', apellidos: 'Jaramillo Cortés', nps: 2, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL MARIANO ESCOBEDO LEON' },
  { nombre: 'Rubén', apellidos: 'Pardo Zepeda', nps: 1, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL AVENIDA CENTRAL' },
  { nombre: 'Carolina', apellidos: 'Uribe Cazares', nps: 9, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL TULTITLAN' },
  { nombre: 'Fabiola', apellidos: 'Camacho Rendón', nps: 2, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL CAZADOR NAUCALPAN' },
  { nombre: 'Leticia', apellidos: 'Gaytán Prieto', nps: 10, region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 3' },
  { nombre: 'Pablo', apellidos: 'Manríquez Solís', nps: 1, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL IGUALA 2' },
  { nombre: 'Beatriz', apellidos: 'Robledo Cifuentes', nps: 10, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ATIZAPAN 2' },
  { nombre: 'Emiliano', apellidos: 'Zúñiga Arriaga', nps: 2, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL PROFETA' },
  { nombre: 'Jacinto', apellidos: 'Delgadillo Rueda', nps: 1, region: 'LEONARDO MAXIMO', zona: 'ISMAEL FERMIN', sucursal: 'SUCURSAL AZTAHUACAN' },
  { nombre: 'Noé', apellidos: 'Ibarra Montiel', nps: 3, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL ALTA TENSION' },
  { nombre: 'Adriana', apellidos: 'Ojeda Villalobos', nps: 8, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL CHALCO' },
  { nombre: 'Efraín', apellidos: 'Terán Osorio', nps: 3, region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL AMECAMECA' },
  { nombre: 'Hugo', apellidos: 'Bautista Ordaz', nps: 5, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL LEON 2' },
  { nombre: 'Ma. del Refugio', apellidos: 'Fierro Alcántara', nps: 3, region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL AV. 11 SUR' },
  { nombre: 'Silvestre', apellidos: 'Lugo Mercado', nps: 0, region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL TOLUCA 1' },
  { nombre: 'Cecilia', apellidos: 'Quintero Amaya', nps: 3, region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL CAZADOR' },
  { nombre: 'Gerardo', apellidos: 'Valencia Pineda', nps: 9, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 2' },
  { nombre: 'Lorenzo', apellidos: 'Cervantes Olmos', nps: 9, region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL ECATEPEC' },
  { nombre: 'Rocío', apellidos: 'Hinojosa Cuevas', nps: 6, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ARAGÓN' },
  { nombre: 'Bernardo', apellidos: 'Nolasco Cabrera', nps: 0, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL MARIANO ESCOBEDO LEON' },
  { nombre: 'Esperanza', apellidos: 'Salgado Beltrán', nps: 6, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL AVENIDA CENTRAL' },
  { nombre: 'Jimena', apellidos: 'Aguirre Peralta', nps: 7, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL TULTITLAN' },
  { nombre: 'Ofelia', apellidos: 'Estrada Bermúdez', nps: 7, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL CAZADOR NAUCALPAN' },
  { nombre: 'Alma Delia', apellidos: 'Jaramillo Cortés', nps: 9, region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 3' },
  { nombre: 'Elsa', apellidos: 'Pardo Zepeda', nps: 6, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL IGUALA 2' },
  { nombre: 'Isaura', apellidos: 'Uribe Cazares', nps: 9, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ATIZAPAN 2' },
  { nombre: 'Nayeli', apellidos: 'Camacho Rendón', nps: 10, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL PROFETA' },
  { nombre: 'Yolanda', apellidos: 'Gaytán Prieto', nps: 9, region: 'LEONARDO MAXIMO', zona: 'ISMAEL FERMIN', sucursal: 'SUCURSAL AZTAHUACAN' },
  { nombre: 'Daniel', apellidos: 'Manríquez Solís', nps: 6, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL ALTA TENSION' },
  { nombre: 'Gloria', apellidos: 'Robledo Cifuentes', nps: 3, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL CHALCO' },
  { nombre: 'Marcela', apellidos: 'Zúñiga Arriaga', nps: 10, region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL AMECAMECA' },
  { nombre: 'Rubén', apellidos: 'Delgadillo Rueda', nps: 7, region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL LEON 2' },
  { nombre: 'Carolina', apellidos: 'Ibarra Montiel', nps: 3, region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL AV. 11 SUR' },
  { nombre: 'Fabiola', apellidos: 'Ojeda Villalobos', nps: 6, region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL TOLUCA 1' },
  { nombre: 'Leticia', apellidos: 'Terán Osorio', nps: 9, region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL CAZADOR' },
  { nombre: 'Pablo', apellidos: 'Bautista Ordaz', nps: 2, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 2' },
  { nombre: 'Beatriz', apellidos: 'Fierro Alcántara', nps: 2, region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL ECATEPEC' },
  { nombre: 'Emiliano', apellidos: 'Lugo Mercado', nps: 2, region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ARAGÓN' },
  { nombre: 'Jacinto', apellidos: 'Quintero Amaya', nps: 9, region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL MARIANO ESCOBEDO LEON' },
  { nombre: 'Noé', apellidos: 'Valencia Pineda', nps: 9, region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL AVENIDA CENTRAL' },
];
